import "../../../../.cache/static-styles-react/build-javascript/compiled.js";
/** @jsxRuntime automatic @jsxImportSource @terraindigital/static-styles-react */
import { runtimeCss as _runtimeCss, mergeProps as _mergeProps } from "@terraindigital/static-styles-react";
import React from 'react';
import { useGridContext } from './context';
interface ColSet extends HtmlPropsNoRef<HTMLDivElement> {
  breakpoints: {
    [key: string]: {
      between: number;
    };
  };
}
const ColSet = ({
  breakpoints,
  ...props
}: ColSet): JSX.Element => {
  const {
    breakpoints: outerBreakpoints
  } = useGridContext();
  const css = React.useMemo(() => ({
    ...Object.fromEntries(Object.entries(breakpoints).map(([selected, {
      between
    }]) => {
      const {
        query
      } = outerBreakpoints[selected];
      return [query, {
        '&>*:not(style)~*:not(style)': {
          marginLeft: `${between}px`
        }
      }];
    })),
    display: 'flex',
    width: '100%',
    margin: 'auto'
  }), [breakpoints, outerBreakpoints]);
  return <div {..._mergeProps({
    css: _runtimeCss(css)
  }, props)} />;
};
export default ColSet;